import React, { useEffect, useState } from "react";
import BartenderCard from "./bartenderCard";
import ChangesAlert from "./alert/ChangesAlert";
import { DELETE } from "@/services/api";
import Alert from "./alert/Alert";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";

const BartendersList = (props: any) => {
  const { refreshToken } = useAppSelector((store) => store.user);
  const LoggedInBusinessId = useAppSelector((store) => store?.user?.business_id) || ''

  const { bartenders } = API_ROUTES
  const [list, setList] = useState<any[]>([...props.data])
  const [modal, setModal] = useState<boolean>(false)
  const [activeId, setActiveId] = useState<string>("")

  const handleDelete = async () => {
    try {
      const response = await DELETE(`${bartenders}/${activeId}?businessId=${LoggedInBusinessId}`, refreshToken);
      setList(list.filter(item => item.id !== activeId))
      Alert({ message: response?.data?.message })
      setModal(false)
    } catch (error) {
      console.log(error);
      setModal(false)
    }
  }
  useEffect(()=>{
    setList(props.data)
  },[props.data.length])
//flex md:flex-row flex-col items-center lg:gap-5 justify-center flex-wrap
  return (
    <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-8 ">
      {list.map((item: object, index: number) => (
          <BartenderCard key={index} setActiveId={setActiveId} setModal={setModal} item={item} index={index} />
      ))}
      <ChangesAlert
        title={"Delete Bartender"}
        desc={`Are you sure you want to delete this Bartender?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => { setModal(false) }}
        handleSaveChanges={handleDelete}
        isOpen={modal} />
    </div>
  );
};

export default BartendersList;
